/**
 * @file Alert Bar.
 */

import { gsap } from 'gsap';
import debounce from 'just-debounce-it';

/**
 * Alert Bar component.
 */
const vAlertBar = () => {
	const alertBar = document.querySelector('.v-alert-bar');

	if (!alertBar) {
		return;
	}

	const seen = !!sessionStorage.getItem(`v_${alertBar.id}_seen`) || false;
	const shouldShow = alertBar.getAttribute('data-active') === 'true' && !seen;
	// const shouldShow = alertBar.getAttribute('data-active') === 'true';

	if (!shouldShow) {
		return;
	}

	const body = document.querySelector('.has-alert-bar');
	const close = alertBar.querySelector('.v-alert-bar__close');
	let isOpen = alertBar.classList.contains('is-active');

	/**
	 * Show the alert bar.
	 */
	const showBar = () => {
		if (isOpen) {
			return;
		}

		const { height } = alertBar.getBoundingClientRect();

		gsap.from(
			alertBar,
			{
				opacity:  0,
				duration: 0.25,
				onUpdate() {
					body.style.setProperty('--alert-bar-height', `${this.progress() * height}px`);
				},
				onComplete: () => {
					alertBar.classList.add('is-active');
					isOpen = true;
				},
			},
		);
	};

	/**
	 * Close alert bar.
	 */
	const closeBar = () => {
		const { height } = alertBar.getBoundingClientRect();

		gsap.to(
			alertBar,
			{
				opacity:  0,
				duration: 0.25,
				onUpdate() {
					body.style.setProperty('--alert-bar-height', `${height * (1 - this.progress())}px`);
				},
				onComplete: () => {
					alertBar.classList.remove('is-active');
					isOpen = false;
					sessionStorage.setItem(`v_${alertBar.id}_seen`, true);
				},
			},
		);
	};

	/**
	 * Set alert bar height.
	 */
	const setHeight = () => {
		if (!isOpen) {
			return;
		}

		const barHeight = alertBar.getBoundingClientRect().height;
		body.style.setProperty('--alert-bar-height', `${barHeight}px`);
	};

	// Init
	window.addEventListener('resize', debounce(setHeight, 250));
	close.addEventListener('click', closeBar);
	document.addEventListener('v-sticky-header-toggle', ({ detail }) => {
		const { stuck } = detail;

		if (!isOpen || !stuck) {
			return;
		}

		closeBar();
	});
	setHeight();
	setTimeout(showBar, parseFloat(alertBar.getAttribute('data-delay'), 10) || 0);
};

export default vAlertBar;
